var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoimmune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    id: "svg38",
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .shield {\n        fill: #fff;\n      }\n\n      .shield, .autoimmune {\n        stroke: #000;\n        stroke-width: 1.5px;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .autoimmune {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Autoimmune",
    transform: "translate(-23,-53)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "autoimmune",
    cx: 36.330002,
    cy: 58.080002,
    r: 2.4300001,
    id: "circle18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "autoimmune3",
    clipPath: "url(#clippath-autoimmune2)",
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "autoimmune",
    d: "m 36.88,62.53 c -0.3,0.06 -1.27,0.16 -2.14,-0.25 l -0.86,-0.35 -3.87,2.69 c -1.65,1.22 -0.16,3.14 1.07,2.24 l 2.76,-1.71 0.33,3.46 -1.81,6.06 c 0.58,1.81 2.47,1.11 2.54,0.46 l 1.42,-4.71 v 0.28",
    id: "path18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "autoimmune2",
    clipPath: "url(#clippath-autoimmune3)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "autoimmune",
    d: "m 35.78,62.53 c 0.3,0.06 1.27,0.16 2.14,-0.25 l 0.86,-0.35 3.87,2.69 c 1.65,1.22 0.16,3.14 -1.07,2.24 l -2.76,-1.71 -0.33,3.46 1.81,6.06 c -0.58,1.81 -2.47,1.11 -2.54,0.46 l -1.42,-4.71 v 0.28",
    id: "path19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4",
    clipPath: "url(#clippath-autoimmune4)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shield",
    d: "m 36.42,61.23 c -2.01,2 -4.64,0.8 -4.64,0.8 0,0 -1.12,5.72 4.7,9.52",
    id: "path21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "autoimmune0",
    clipPath: "url(#clippath-autoimmune5)",
    id: "g23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shield",
    d: "m 36.23,61.23 c 2.01,2 4.64,0.8 4.64,0.8 0,0 1.12,5.72 -4.7,9.52",
    id: "path22"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "autoimmune",
    points: "36.64 66.6 36.88 64.52 38.43 65.56 38.64 62.81",
    id: "polyline24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoimmune);
export default __webpack_public_path__ + "static/media/Autoimmune.5654a8aeac2576589e61cdb0bc93d3cf.svg";
export { ForwardRef as ReactComponent };